module.exports = __webpack_public_path__ + "teenagers-image.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-categories/assets/teenagers-image.png
// module id = 1174
// module chunks = 10